import React, { useEffect, useState } from "react";
import { Table, Input, Modal } from "antd";
import { get } from "../../api/axios";
import { Pagination } from "antd";
import SearchBar from "../../utils/SearchBar";

const Reservations = () => {
  const columns = [
    //1
    //بيانات الحجز
    {
      title: (
        <>
          بيانات الحجز
          <br />
          رقم الحجز
          <br />
          حالة الحجز <br />
          مصدر الحجز
          <br />
          جهة الحجز
          <br />
          تاريخ إنشاء الحجز
          <br />
          وقت إنشاء الحجز
          <br />
          كود الوحدة
          <br />
          سياسة الإلغاء
        </>
      ),
      render: ({
        id,
        status,
        reservation_source,
        date_of_creation,
        time_of_creation,
        reservation_os,
        cancellation_policy,
        property,
      }) => (
        <>
          {id || "-"} <br />
          {status || "-"} <br />
          {reservation_source === "user" ? "مكان" : "مضيف"} <br />
          {reservation_os || "-"} <br />
          {date_of_creation || "-"}
          <br /> {time_of_creation || "-"} <br />
          {property?.id ? `U${property?.id}` : "-"}
          <br />
          {cancellation_policy || "-"}
        </>
      ),
    },

    //2
    //بيانات الاقامة
    {
      title: (
        <>
          بيانات الإقامة
          <br />
          اسم الوحدة
          <br />
          المدينة
          <br />
          الحي <br />
          تاريخ الوصول
          <br />
          تاريخ المغادرة
          <br />
          وقت الوصول
          <br />
          وقت المغادرة
          <br />
          مدة الإقامة
        </>
      ),
      render: ({ arrives_leaves, daysNumbers, property }) => {
        const splitDateRange = (date) => {
          if (!date || typeof date !== "string") {
            return { from: "-", to: null };
          }

          const parts = date.split(" - ");

          return {
            from: parts[0],
            to: parts[1] || null,
          };
        };

        const { from, to } = splitDateRange(arrives_leaves?.date);

        return (
          <div>
            {property?.name || "-"}
            <br />
            {property?.city || "-"}
            <br />
            {property?.district || "-"}
            <br />
            {from}
            {to && <div>{to}</div>}

            {arrives_leaves?.arriving_time || "-"}
            <br />
            {arrives_leaves?.leaving_time || "-"}
            <br />
            {daysNumbers || "-"}
          </div>
        );
      },
    },

    //3
    //بيانات الضيف والمضيف
    {
      title: (
        <>
          بيانات الضيف والمضيف
          <br />
          أسم الضيف
          <br />
          البريد الالكتروني
          <br />
          الجوال
          <br />
          رقم الضيف
          <br />
          أسم المضيف
          <br />
          البريد الالكتروني
          <br />
          الجوال
          <br />
          رقم المضيف
          <br />
        </>
      ),
      render: ({ user, owner }) => (
        <>
          {user?.name || "-"} <br />
          {user?.email || "-"} <br />
          {user?.phone || "-"} <br />
          {user?.id ? `G${user?.id}` : "-"} <br />
          {owner?.name || "-"} <br />
          {owner?.email || "-"} <br />
          {owner?.phone || "-"} <br />
          {owner?.id ? `H${owner?.id}` : "-"}
        </>
      ),
    },

    //4
    // بيانات السعر
    {
      title: (
        <>
          بيانات السعر
          <br />
          طريقة السداد
          <br />
          المدة * سعر الليلة
          <br />
          إجمالي السعر
          <br />
          العرض
          <br />
          كود خصم
          <br />
          كود المنصة
          <br />
          مبلغ الحجز
          <br />
          رسوم الخدمة
          <br />
          المجموع
        </>
      ),

      render: ({
        prices,
        daysNumbers,
        total_price,
        payment_method,
        reservation_source,
      }) => (
        <>
          {reservation_source === "user" ? payment_method || "-" : "-"} <br />
          {reservation_source === "user"
            ? `${daysNumbers} * ${prices.avg_price}`
            : "-"}{" "}
          <br />
          {reservation_source === "user" ? prices.subTotal : "-"} <br />
          {reservation_source === "user" ? prices.offers_amount : "-"} <br />
          {reservation_source === "user" ? prices.coupon_amount : "-"} <br />
          كود المنصة
          <br />
          {reservation_source === "user"
            ? prices.total_price_without_service
            : "-"}{" "}
          <br />
          {reservation_source === "user" ? prices.total_service : "-"} <br />
          {total_price} <br />
        </>
      ),
    },

    //5
    // تقييم الضيف للوحدة
    {
      title: (
        <>
          تقييم الضيف للوحدة
          <br />
          التقييم العام
          <br />
          النظافة
          <br />
          الحالة
          <br />
          الخدمة
          <br />
          الجودة
          <br />
          التطابق
          <br />
          رقم تقييم الضيف
          <br />
          معلق
        </>
      ),
      render: ({ rate }) => (
        <>
          {rate && (
            <>
              {rate?.date || "-"} <br /> {rate?.total_rating || "-"} <br />{" "}
              {rate?.clean || "-"}
              <br /> {rate?.new || "-"} <br /> {rate?.service || "-"} <br />{" "}
              {rate?.pricing || "-"}
              <br /> {rate?.matching || "-"} <br />
            </>
          )}
        </>
      ),
    },

    //6
    //تقييم المضيف للضيف
    {
      title: (
        <>
          تقييم المضيف للضيف
          <br />
          التقييم العام
          <br />
          اللباقة
          <br />
          المحافظة
          <br />
          الحرص
          <br />
          الالتزام
          <br />
          الترحيب
          <br />
          رقم تقييم المضيف
          <br />
          منشور
        </>
      ),
      render: ({ owner_rate }) => (
        <>
          {owner_rate && (
            <>
              {owner_rate.date} <br />
              {owner_rate.total_rating} <br />
              {owner_rate.clean} <br />
              {owner_rate.care} <br />
              {owner_rate.instructions} <br />
              {owner_rate.satisfaction} <br />
              {owner_rate.tact} <br />
            </>
          )}
        </>
      ),
    },

    // //7
    // // بيانات الإيداع
    {
      title: (
        <>
          بيانات الإيداع
          <br />
          المدفوع من الضيف
          <br />
          رسوم الإيداع
          <br />
          ضريبة رسوم الإيداع
          <br />
          رسوع الإيداع وضريبته
          <br />
          مبلغ الإيداع
          <br />
          تاريخ الإيداع
          <br />
          SPAN CARD
          <br />
          مرفق الإيداع
        </>
      ),
      render: ({ owner_rate }) => (
        <>
          {owner_rate && (
            <>
              المدفوع من الضيف
              <br />
              رسوم الإيداع
              <br />
              ضريبة رسوم الإيداع
              <br />
              رسوع الإيداع وضريبته
              <br />
              مبلغ الإيداع
              <br />
              تاريخ الإيداع
              <br />
              SPAN CARD
              <br />
              مرفق الإيداع
            </>
          )}
        </>
      ),
    },

    //8
    // بيانات الحوالة
    {
      title: (
        <>
          بيانات الحوالة
          <br />
          رقم الحوالة
          <br />
          مبلغ الحوالة
          <br />
          حالة الحوالة
          <br />
          تاريخ الحوالة
          <br />
        </>
      ),
      dataIndex: "",
    },

    //9
    //بيانات الاسترداد
    {
      title: (
        <>
          بيانات الاسترداد
          <br />
          رقم الاسترداد
          <br />
          مبلغ الاسترداد
          <br />
          تاريخ الاسترداد
        </>
      ),
      dataIndex: "",
    },

    //10
    //زر الايداع
    {
      title: <>الإيداع</>,
      render: (record) => (
        <button
          className="btn btn-primary py-1 mt-1"
          onClick={() => {
            setSelectedReservation(record.id);
            setOpenDepositModal(true);
          }}
        >
          الإيداع
        </button>
      ),
    },
    //   {
    //   title: (
    //     <>
    //       بيانات الضيف
    //       <br />
    //       الاسم
    //       <br />
    //       الجوال
    //       <br />
    //       البريد الالكتروني
    //       <br />
    //       رقم الضيف
    //       <br />
    //     </>
    //   ),
    //   render: ({ user }) => (
    //     <>
    //       {/* رقم الضيف : {user.id} <br /> */}
    //       {user.name} <br />
    //       {user.phone} <br />
    //       {user.email} <br />
    //     </>
    //   ),
    // },
    // {
    //   title: "انشاء حوالة",
    //   render: ({
    //     id,
    //     reservation_source,
    //     total_price,
    //     status,
    //     has_payout,
    //     is_payable,
    //   }) => (
    //     <>
    //       {reservation_source === "user" && (
    //         // <button
    //         //   disabled={!has_payout & is_payable ? false : true}
    //         //   className="btn btn-outline-warning btn-sm p-0"
    //         // >
    //         //   <Link
    //         //     className="color-inherit text-decoration-none py-1 px-2 d-block"
    //         //     to={`/payouts/create/${id}`}
    //         //   >
    //         //     {!has_payout ? (
    //         //       <>
    //         //         <FileAddOutlined />
    //         //         انشاء
    //         //       </>
    //         //     ) : (
    //         //       <>تم انشاء حوالة بالفعل</>
    //         //     )}
    //         //   </Link>
    //         // </button>
    //         <button className="btn btn-outline-warning btn-sm p-0">
    //           <Link
    //             className="color-inherit text-decoration-none py-1 px-2 d-block"
    //             to={{
    //               pathname: `/payouts/create/${id}`,
    //               state: { amount: total_price },
    //             }}
    //           >
    //             <>
    //               <FileAddOutlined />
    //               انشاء
    //             </>
    //           </Link>
    //         </button>
    //       )}
    //     </>
    //   ),
    // },
  ];

  const [data, setData] = useState([]);

  const [openDepositModal, setOpenDepositModal] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [selectedReservation, setSelectedReservation] = useState(null);

  const [form, setForm] = useState({
    guest_paid: "",
    deposit_fee: "",
    deposit_fee_tax: "",
    deposit_fee_with_tax: "",
    deposit_amount: "",
    deposit_date: "",
    span_card: "",
    deposit_attachment: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleDepositSubmit = () => {
    setConfirmLoading(true);

    setTimeout(() => {
      console.log("Deposit Data:", form, "Reservation:", selectedReservation);

      setConfirmLoading(false);
      setOpenDepositModal(false);

      setForm({
        guest_paid: "",
        deposit_fee: "",
        deposit_fee_tax: "",
        deposit_fee_with_tax: "",
        deposit_amount: "",
        deposit_date: "",
        span_card: "",
        deposit_attachment: "",
      });
    }, 800);
  };

  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedValue, setDebouncedValue] = useState(searchQuery);

  const [total, setTotal] = useState(1);

  useEffect(() => {
    get(`reservations?search=${searchQuery}`).then((res) => {
      setData(res?.data.data);
      setTotal(res?.data.meta.last_page);
      setLoading(false);
    });
  }, [debouncedValue]);

  const handlePagination = (pageNumber) => {
    setLoading(true);

    get(`reservations?page=${pageNumber}`).then((res) => {
      setData(res.data.data);
      setLoading(false);
    });
  };

  return (
    <div>
      <div className="row">
        <SearchBar
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          debouncedValue={debouncedValue}
          setDebouncedValue={setDebouncedValue}
        />
        <div className="col-12 grid-margin stretch-card">
          <div className="w-100">
            <Table
              rowKey="id"
              locale={{ emptyText: "لا يوجد عناصر" }}
              loading={loading}
              pagination={false}
              bordered
              scroll={{
                y: "65vh",
                x: 1650,
              }}
              columns={columns}
              dataSource={data}
              size="middle"
            />
            <Pagination
              defaultCurrent={1}
              className="mt-4 d-flex align-items-center justify-content-center"
              position="bottomCenter"
              total={total * 10}
              onChange={handlePagination}
            />
          </div>
        </div>
      </div>

      <Modal
        title="إضافة إيداع"
        open={openDepositModal}
        onOk={handleDepositSubmit}
        confirmLoading={confirmLoading}
        onCancel={() => setOpenDepositModal(false)}
        okText="حفظ"
        cancelText="إغلاق"
        width={800}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
          }}
        >
          {/* RIGHT */}

          <div>
            <label style={{ marginBottom: "6px", display: "block" }}>
              المدفوع من الضيف
            </label>
            <Input
              name="guest_paid"
              value={form.guest_paid}
              onChange={handleChange}
            />
          </div>

          <div>
            <label style={{ marginBottom: "6px", display: "block" }}>
              مبلغ الإيداع
            </label>
            <Input
              name="deposit_amount"
              value={form.deposit_amount}
              onChange={handleChange}
            />
          </div>

          <div>
            <label style={{ marginBottom: "6px", display: "block" }}>
              رسوم الإيداع
            </label>
            <Input
              name="deposit_fee"
              value={form.deposit_fee}
              onChange={handleChange}
            />
          </div>

          <div>
            <label style={{ marginBottom: "6px", display: "block" }}>
              تاريخ الإيداع
            </label>
            <Input
              type="date"
              name="deposit_date"
              value={form.deposit_date}
              onChange={handleChange}
            />
          </div>

          <div>
            <label style={{ marginBottom: "6px", display: "block" }}>
              ضريبة رسوم الإيداع
            </label>
            <Input
              name="deposit_fee_tax"
              value={form.deposit_fee_tax}
              onChange={handleChange}
            />
          </div>

          <div>
            <label style={{ marginBottom: "6px", display: "block" }}>
              SPAN CARD
            </label>
            <Input
              name="span_card"
              value={form.span_card}
              onChange={handleChange}
            />
          </div>

          <div>
            <label style={{ marginBottom: "6px", display: "block" }}>
              رسوم الإيداع وضريبته
            </label>
            <Input
              name="deposit_fee_with_tax"
              value={form.deposit_fee_with_tax}
              onChange={handleChange}
            />
          </div>

          <div>
            <label style={{ marginBottom: "6px", display: "block" }}>
              مرفق الإيداع
            </label>
            <Input
              name="deposit_attachment"
              value={form.deposit_attachment}
              onChange={handleChange}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Reservations;
